// ===================================
// KAIXO - Visor de vídeo fullscreen
// Espejo de ImageViewer pero para <video>. Se usa desde el carrusel de
// Latidos para abrir un vídeo a pantalla completa cuando el usuario
// toca el contenido (evita depender del requestFullscreen nativo del
// WebView Android, que no siempre funciona).
//
// IMPORTANTE: el <video> hereda la clase '.imgv-img' del CSS de
// ImageViewer, que tiene 'opacity: 0' por defecto y solo se vuelve
// visible cuando se le añade '.is-ready'. Sin el handler 'onLoadedData'
// el video se reproducía pero quedaba transparente al 100% — el user
// oía el audio pero no veía nada.
// ===================================

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { downloadMedia } from '../../utils/downloadMedia';
import './ImageViewer.css';

function VideoViewer({ src, onClose }) {
    const [ready, setReady] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const handleDownload = async (e) => {
        e?.stopPropagation();
        if (downloading) return;
        setDownloading(true);
        const r = await downloadMedia(src, 'video');
        setDownloading(false);
        try {
            const msg = r.ok ? '✅ Video guardado' : `❌ ${r.error || 'Error al descargar'}`;
            window.dispatchEvent(new CustomEvent('show_notification', { detail: msg }));
        } catch {}
    };
    if (!src) return null;
    return ReactDOM.createPortal(
        <div className="imgv-overlay" onClick={onClose}>
            <button className="imgv-close" onClick={onClose}>✕</button>
            <button className="imgv-download" onClick={handleDownload} aria-label="Descargar" disabled={downloading}>
                {downloading ? '…' : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 4v12" />
                        <polyline points="6 11 12 17 18 11" />
                        <path d="M5 20h14" />
                    </svg>
                )}
            </button>
            <video
                src={src}
                className={`imgv-img ${ready ? 'is-ready' : ''}`}
                controls
                autoPlay
                playsInline
                preload="auto"
                onLoadedData={() => setReady(true)}
                onCanPlay={() => setReady(true)}
                onClick={e => e.stopPropagation()}
            />
        </div>,
        document.body
    );
}

export default VideoViewer;
